var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { QueryClient, QueryObserver } from 'react-query';
import { observable, runInAction } from 'mobx';
import { Singleton } from '~/services/service.base';
export let MobxQuery = class MobxQuery {
    queryClient = new QueryClient();
    defaultOptions;
    observer;
    reactQueryResult = observable({}, { deep: false });
    subscription;
    constructor(options = {}) {
        const { ...defaultOptions } = this.queryClient.defaultQueryOptions(options);
        this.defaultOptions = defaultOptions;
    }
    query(options) {
        const opts = Object.assign({}, this.defaultOptions, options);
        if (this.observer) {
            this.observer.setOptions(opts);
        }
        else {
            const observer = (this.observer = new QueryObserver(this.queryClient, opts));
            runInAction(() => Object.assign(this.reactQueryResult, observer.getCurrentResult()));
            this.subscription = observer.subscribe(result => {
                runInAction(() => Object.assign(this.reactQueryResult, result));
            });
        }
        return this.reactQueryResult;
    }
    dispose() {
        this.subscription?.();
    }
};
MobxQuery = __decorate([
    Singleton(),
    __metadata("design:paramtypes", [Object])
], MobxQuery);
